import { createSlice } from "@reduxjs/toolkit";

export const notifSlice = createSlice({
  name: "notifications",
  initialState: {
    notifs: [],
  },
  reducers: {
    pushNotif: (state, action) => {
      state.notifs = [
        {
          id: state.notifs.length,
          ...action.payload,
          readed: false,
          date: new Date(),
        },
        ...state.notifs,
      ];
    },
    readNotif: (state, action) => {
      const updateNotif = state.notifs.findIndex(
        (obj) => obj.id === action.payload.id
      );
      state.notifs[updateNotif].readed = true;
    },
    readAllNotifs: (state, action) => {
      const list = state.notifs.map((item) => {
        item.readed = true;

        return item;
      });
      state.notifs = list;
    },
    deleteNotif: (state, action) => {
      const list = state.notifs.filter((item) => item.id !== action.payload.id);
      state.notifs = list;
    },
    deleteAllNotifs: (state, action) => {
      state.notifs = [];
    },
  },
});

export const {
  pushNotif,
  readNotif,
  readAllNotifs,
  deleteNotif,
  deleteAllNotifs,
} = notifSlice.actions;

export default notifSlice.reducer;
